import { render, staticRenderFns } from "./CompanySearch.vue?vue&type=template&id=ae7df2c4&"
import script from "./CompanySearch.vue?vue&type=script&lang=ts&"
export * from "./CompanySearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports